import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavbarStyles.css'; // Assuming you have a separate CSS file for custom styles

const Navbar2 = () => {
    const [showCourses, setShowCourses] = useState(false);
    const [showJobOriented, setShowJobOriented] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false); // State for controlling Navbar collapse

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50); // Navbar becomes solid after 50px scroll
        };

        window.addEventListener('scroll', handleScroll,{ passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Function to close the Navbar when a link is clicked on small devices
    const handleNavLinkClick = () => {
        setExpanded(false); // Collapse the Navbar
    };

    return (
        <Navbar className={`navbar-custom ${isScrolled ? 'navbar-solid' : ''}`} expand="lg" fixed="top" expanded={expanded}>
            <Container>
                {/* <Navbar.Brand as={Link} to="/">
                    <img src="" alt="Logo" width="100" height="80" /> 
                </Navbar.Brand> */}

                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/" className="nav-link-custom mx-1" onClick={handleNavLinkClick}>Home</Nav.Link>
                        <Nav.Link as={Link} to="/about-us" className="nav-link-custom mx-1" onClick={handleNavLinkClick}>About Us</Nav.Link>

                        {/* Short Term Courses Dropdown */}
                        <NavDropdown
                            title={<span className="nav-dropdown-toggle">Short Term Courses</span>}
                            id="courses-dropdown"
                            className="nav-link-custom mx-1"
                            // show={showCourses}
                            show={undefined}
                            onMouseEnter={() => setShowCourses(true)}
                            onMouseLeave={() => setShowCourses(false)}
                        >
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#c" onClick={handleNavLinkClick}>C Programming</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#C++" onClick={handleNavLinkClick}>C++ Programming</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#java" onClick={handleNavLinkClick}>Java</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#python" onClick={handleNavLinkClick}>Python</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#sql" onClick={handleNavLinkClick}>SQL</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#linux" onClick={handleNavLinkClick}>Linux</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#basic" onClick={handleNavLinkClick}>Basic Office</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/short-term-courses#hcj" onClick={handleNavLinkClick}>HTML / CSS / JS</NavDropdown.Item>
                        </NavDropdown>

                        {/* Job Oriented Courses Dropdown */}
                        <NavDropdown
                            title={<span className="nav-dropdown-toggle">Job Oriented Courses</span>}
                            id="certifications-dropdown"
                            className="nav-link-custom mx-1"
                            // show={showJobOriented}
                             show={undefined}
                            onMouseEnter={() => setShowJobOriented(true)}
                            onMouseLeave={() => setShowJobOriented(false)}
                        >
                            <NavDropdown.Item as={HashLink} to="/job-oriented-courses#full-stack-development" onClick={handleNavLinkClick}>Full Stack Development</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/job-oriented-courses#python-data-science" onClick={handleNavLinkClick}>Python with Data Science</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/job-oriented-courses#datacom-networking" onClick={handleNavLinkClick}>Datacom Networking</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/job-oriented-courses#competitive-programming" onClick={handleNavLinkClick}>Competitive Programming</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/job-oriented-courses#agile-devops" onClick={handleNavLinkClick}>Agile / DevOps</NavDropdown.Item>
                            <NavDropdown.Item as={HashLink} to="/job-oriented-courses#cloud-computing" onClick={handleNavLinkClick}>Cloud Computing</NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Link as={Link} to="/custing" className="nav-link-custom mx-1" onClick={handleNavLinkClick}>Customized Training</Nav.Link>
                        <Nav.Link as={Link} to="/batchscheduel" className="nav-link-custom mx-1" onClick={handleNavLinkClick}>Batch Schedule</Nav.Link>
                        <Nav.Link as={Link} to="/query" className="nav-link-custom mx-1" onClick={handleNavLinkClick}>To Partner</Nav.Link>
                        <Nav.Link as={Link} to="/student-login" className="nav-link-custom mx-1" onClick={handleNavLinkClick}>Student login</Nav.Link>
                        <Nav.Link as={Link} to="/query" className="enroll-link" onClick={handleNavLinkClick}>For Query</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navbar2;
